import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { FansPoint } from "../types";

export function FansChart({ history }: { history: FansPoint[] }) {
  if (history.length === 0) {
    return (
      <div className="flex h-32 items-center justify-center rounded-md border border-dashed border-ink-200 text-xs text-ink-400">
        还没数据点。在下方记录一条吧。
      </div>
    );
  }
  const data = history.map((p) => ({ date: p.date, fans: p.fans, note: p.note || "" }));
  const first = data[0].fans;
  const last = data[data.length - 1].fans;
  const delta = last - first;
  const deltaCls =
    delta > 0
      ? "text-emerald-600"
      : delta < 0
        ? "text-red-600"
        : "text-ink-500";
  return (
    <div className="space-y-1">
      <div className="text-xs text-ink-500">
        {data[0].date}: <b className="text-ink-700">{first}</b> →{" "}
        {data[data.length - 1].date}: <b className="text-ink-700">{last}</b>{" "}
        <span className={deltaCls}>
          ({delta >= 0 ? "+" : ""}
          {delta})
        </span>
      </div>
      <div style={{ width: "100%", height: 180 }}>
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 6, right: 12, bottom: 0, left: -10 }}>
            <defs>
              <linearGradient id="fansFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#6366f1" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#6366f1" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#64748b" }} />
            <YAxis tick={{ fontSize: 11, fill: "#64748b" }} width={48} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 6, border: "1px solid #e2e8f0" }}
              labelStyle={{ color: "#475569", fontWeight: 600 }}
            />
            <Area
              type="monotone"
              dataKey="fans"
              stroke="#6366f1"
              strokeWidth={2}
              fill="url(#fansFill)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
